const UPGRADE_INTENT_KEY = "lexiUpgradeIntent";
export const UPGRADE_EVENT_NAME = "lexi:upgrade-requested";

export const isPaidSubscriptionStatus = (status) => {
  const normalized = (status || "").toLowerCase();
  return ["active", "trialing", "past_due", "unpaid"].includes(normalized);
};

// Free users and 7-Day Pass holders (a one-time payment, no subscription) buy
// through the in-app checkout, which takes its prices from the stripe-prices
// API. Only a live recurring subscription changes plan via upgradeSubscription.
export const buysThroughInAppCheckout = ({
  isNonStripeUser,
  subscriptionDetails,
  tokenSubscriptions = [],
}) => {
  // The JWT's subscriptions come first: the account page shows an old 7-Day Pass
  // ahead of a subscription bought later, and a second purchase would duplicate it
  if (tokenSubscriptions.some((sub) => isPaidSubscriptionStatus(sub?.status))) {
    return false;
  }
  if (isNonStripeUser) return true;
  const subscription = subscriptionDetails?.subscriptions?.[0];
  if (!subscription || subscription.interval === "one_time") return true;
  return !isPaidSubscriptionStatus(subscription.status);
};

const markUpgradeIntent = () => {
  try {
    if (typeof window !== "undefined") {
      sessionStorage.setItem(UPGRADE_INTENT_KEY, "true");
    }
  } catch (error) {
    console.error("Unable to persist upgrade intent", error);
  }
};

const clearUpgradeIntent = () => {
  try {
    if (typeof window !== "undefined") {
      sessionStorage.removeItem(UPGRADE_INTENT_KEY);
    }
  } catch (error) {
    console.error("Unable to clear upgrade intent", error);
  }
};

export const triggerUpgradeFlow = () => {
  if (typeof window === "undefined") return;

  markUpgradeIntent();

  // If already on the dashboard, ask it to open the upgrade flow immediately
  if (window.location.pathname.startsWith("/app/dashboard")) {
    window.dispatchEvent(new Event(UPGRADE_EVENT_NAME));
    return;
  }

  // Otherwise navigate to dashboard with an upgrade hint
  const url = new URL("/app/dashboard", window.location.origin);
  url.searchParams.set("upgrade", "1");
  window.location.href = url.toString();
};

export const consumeUpgradeIntent = () => {
  if (typeof window === "undefined") return false;

  let hasIntent = false;

  try {
    const url = new URL(window.location.href);
    if (url.searchParams.get("upgrade") === "1") {
      hasIntent = true;
      url.searchParams.delete("upgrade");
      window.history.replaceState({}, "", url);
    }

    if (sessionStorage.getItem(UPGRADE_INTENT_KEY) === "true") {
      hasIntent = true;
    }
  } catch (error) {
    console.error("Unable to read upgrade intent", error);
  }

  if (hasIntent) {
    clearUpgradeIntent();
  }

  return hasIntent;
};
